/**
 * Created by JAVIER on 10/31/2019.
 */
import React from 'react'
import * as constants from './constants'
import { Tree, Menu, Icon, Dropdown } from 'antd'
import treeService from './../services/tree.service'
const { TreeNode, DirectoryTree } = Tree

class FolderTree extends React.Component {
  constructor() {
    super()
    this.dragEnterKey = ''
    this.expandTimer = null
  }

  renderMenu = () => {
    const permissions = this.props.permissions;
    const items = []
    if ( !permissions ) return;
    for (const permission of permissions){
        switch (permission) {
            case "create":
                items.push(
                    <Menu.Item key={constants.ADD_FOLDER}>
                        <Icon type="folder-add"/>
                        <span>Add folder</span>
                    </Menu.Item>
                )
                break;
            case "cut":
                items.push(
                    <Menu.Item key={constants.CUT_FOLDER}>
                        <Icon type="scissor"/>
                        <span>Cut folder</span>
                    </Menu.Item>
                )
                break;
            case "delete":
                items.push(
                    <Menu.Item key={constants.DELETE_FOLDER}>
                        <Icon type="delete"/>
                        <span>Delete folder</span>
                    </Menu.Item>
                )
                break;
            case "paste":
                items.push(
                    <Menu.Item key={constants.PASTE_FOLDER}>
                        <Icon type="snippets"/>
                        <span>Paste folder</span>
                    </Menu.Item>
                )
                break;
            case "rename":
                items.push(
                    <Menu.Item key={constants.RENAME_FOLDER}>
                        <Icon type="edit"/>
                        <span>Rename folder</span>
                    </Menu.Item>
                )
                break;
        }
    }
    if ( permissions.includes("upload")){
        items.push(<Menu.Divider />)
        items.push(
            <Menu.Item key={constants.UPLOAD_FILES}>
                <Icon type="upload"/>
                <span className="ant-upload-text">Upload files</span>
            </Menu.Item>
        )
    }
    return (
        <Menu onClick={this.props.onClickMenu}>
            {items}
        </Menu>
    )
  }

  renderTreeNodes = data =>
    data.map(item => {
      if (item.children) {
        return (
          <TreeNode
            title={this.dropdownCtxMenu(item)}
            key={item._id}
            dataRef={item}
            icon={
              <Icon
                type="folder"
                theme={'filled'}
                style={treeService.renderTreeNodeIconStyles(item)}
              />
            }
          >
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        )
      }
      return (
        <TreeNode
          title={this.dropdownCtxMenu(item)}
          key={item._id}
          dataRef={item}
          icon={
            <Icon
              type="folder"
              theme={'filled'}
              style={treeService.renderTreeNodeIconStyles(item)}
            />
          }
        />
      )
    })

  dropdownCtxMenu = treeNode => {
    return (
      <Dropdown overlay={this.renderMenu()} trigger={['contextMenu']} >
        <span
          style={treeService.renderTreeNodeTextStyles(treeNode)}
          className="tree-node-title"
          data-key={treeNode._id}
          draggable="true"
          onDragStart={e => {
            e.dataTransfer.setData(
              'data',
              JSON.stringify({
                id: e.currentTarget.getAttribute('data-key'),
                type: 'folder',
              })
            )
            e.dataTransfer.dropEffect = 'move'
          }}
          onDragEnter={e => {
            e.currentTarget.style.background = 'gray'

            const key = e.currentTarget.getAttribute('data-key')
            if (key !== this.dragEnterKey) {
              this.dragEnterKey = key
              if (this.expandTimer) clearTimeout(this.expandTimer)
              this.expandTimer = setTimeout(() => {
                console.log('running time out', this.dragEnterKey, key)
                if (
                  this.dragEnterKey === key &&
                  !this.props.expandedKeys.includes(key)
                ) {
                  this.props.expandedKeys.push(key)
                  this.props.onExpand(this.props.expandedKeys)
                  //this.setState({expandedKeys: this.state.expandedKeys});
                }
              }, 1000)
            }
          }}
          onDragLeave={e => {
            e.currentTarget.style.border = ''
            e.currentTarget.style.background = ''
          }}
          onDragOver={e => {
            e.preventDefault()
            e.dataTransfer.dropEffect = 'move'
          }}
          onDrop={e => {
            const targetFolderId = e.currentTarget.getAttribute('data-key')
            const data = JSON.parse(e.dataTransfer.getData('data'))
            if (data.type === 'photo') {
              const fileId = data.id
              this.props.onMoveFiles([fileId], targetFolderId)
            }

            if (data.type === 'folder') {
              const folderId = data.id
              this.props.onMoveFolder(folderId, targetFolderId)
            }
            e.currentTarget.style.border = ''
            e.currentTarget.style.background = ''
          }}
        >
          {treeNode.text}
        </span>
      </Dropdown>
    )
  }

  render() {
    return (
      <DirectoryTree
        multiple
        defaultExpandAll
        onSelect={this.props.onSelect}
        onExpand={this.props.onExpand}
        selectedKeys={this.props.selectedKeys}
        expandedKeys={this.props.expandedKeys}
        loadData={this.props.onLoadData}
      >
        {this.renderTreeNodes(this.props.treeData)}
      </DirectoryTree>
    )
  }
}

export default FolderTree
